import { Component, Injector } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, switchMap } from 'rxjs/operators';
import { MfaService } from '../../../../../aumico-lib-users-fe/src/lib/services/mfa.service';
import { Paths } from '../../enums/paths.enum';
import { localizationKeys } from '../../utils/localizationKeys';
import { BasePageComponent } from '../base.page';

@UntilDestroy()
@Component({
    selector: 'passwords-base',
    template: `<ng-content></ng-content>`,
})
export class PasswordsBasePage extends BasePageComponent {
    loginQuestionTextKey = localizationKeys.aumico_reports_registration_bottom_question;
    loginQuestionButtonTextKey = localizationKeys.aumico_reports_registration_bottom_button_of_question_login;

    protected readonly mfaService: MfaService;

    constructor(injector: Injector) {
        super(injector);
        this.mfaService = injector.get(MfaService);
    }

    readonly questionButtonClickedAction = (): void => {
        this.navigateToLoginPage();
    };

    onSetOrResetPasswordSuccess(): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        this.mfaService
            .checkMfa$()
            .pipe(
                switchMap((mfaCheck) =>
                    this.mfaService.forceTokenRefresh$().pipe(map(() => mfaCheck.status)),
                ),
                untilDestroyed(this),
            )
            .subscribe({
                next: (status) => {
                    if (status === 'SETUP_REQUIRED') {
                        this.router.navigate([`/${currentLanguage}/auth/2fa/setup`]);
                    } else if (status === 'VERIFY_REQUIRED') {
                        this.router.navigate([`/${currentLanguage}/auth/2fa/verify`]);
                    } else {
                        this.authProvider.dispatchGetCurrentUser();
                        this.router.navigate([`/${currentLanguage}/${Paths.HOME}`]);
                    }
                },
            });
    }

    onResendVerificationMail(email: string): void {
        this.navigatToConfirmationPage(email);
    }

    private navigateToLoginPage(): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        this.router.navigate([`/${currentLanguage}`, Paths.AUTH, Paths.LOGIN]);
    }

    private navigatToConfirmationPage(email: string): void {
        const currentLanguage = this.getCurrentLanguageWithFallBack();
        this.router.navigate([`/${currentLanguage}`, Paths.AUTH, Paths.CONFIRM_ACCOUNT], {
            queryParams: { email },
            queryParamsHandling: 'merge',
        });
    }
}
